import { learningServiceRequest, skip } from "@/services/utils";
import { DEFAULT_LIMIT_PER_PAGE } from "../constants";
import _ from "lodash";

const bookingService = {
  async createBookings(payload) {
    return await learningServiceRequest({
      method: "post",
      url: "/bookings",
      payload,
    });
  },
  async updateBooking(bookingId, payload) {
    return await learningServiceRequest({
      method: "put",
      url: `/bookings/${bookingId}`,
      payload,
    });
  },
  async getBookings({
    limit = DEFAULT_LIMIT_PER_PAGE,
    page = 1,
    q = "",
    extraParams = {},
    failureMessage = "Error loading bookings data",
    source,
  }) {
    if (
      !_.isEmpty(extraParams.bed_ids) &&
      !extraParams.bed_ids.includes(null)
    ) {
      return await learningServiceRequest({
        method: "get",
        url: "/bookings",
        params: {
          limit,
          skip: skip(page, limit),
          q,
          ...extraParams,
        },
        source,
        failureMessage,
      });
    }
    return [];
  },
};

export default bookingService;
